"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorType = void 0;
var ErrorType;
(function (ErrorType) {
    ErrorType["BAD_REQUEST"] = "BadRequest";
    ErrorType["NOT_FOUND"] = "NotFound";
    ErrorType["CONFLICT"] = "Conflict";
    ErrorType["COMPANY_MEMBER_LIST_ACCESS_VIOLATION_ERROR"] = "CompanyMemberListAccessViolationError";
    ErrorType["COMPANY_MANAGEMENT_ACCESS_VIOLATION_ERROR"] = "CompanyManagementAccessViolationError";
    ErrorType["USER_NOT_AUTHENTICATED_ERROR"] = "UserNotAuthenticatedError";
    ErrorType["LOCALE_HAS_INVALID_FORMAT"] = "LocaleHasInvalidFormat";
    ErrorType["COUNTRY_CODE_HAS_INVALID_FORMAT"] = "CountryCodeHasInvalidFormat";
    ErrorType["COUNTRY_STATE_CODE_HAS_INVALID_FORMAT"] = "CountryStateCodeHasInvalidFormat";
    ErrorType["COMPANY_TYPE_HAS_INVALID_FORMAT"] = "CompanyTypeHasInvalidFormat";
    ErrorType["MSP_ADMIN_MODIFICATION_VIOLATION_ERROR"] = "MspAdminModificationViolationError";
    ErrorType["CANT_CREATE_MULTIPLE_COMPANIES_WITH_KSC_HOSTED_SERVICE"] = "CantCreateMultipleCompaniesWithKscHostedService";
    ErrorType["FEATURE_ACCESS_DENIED"] = "FeatureAccessDenied";
    ErrorType["INVALID_EMAIL_ERROR"] = "InvalidEmailError";
    ErrorType["WORKSPACE_NOT_FOUND_ERROR"] = "WorkspaceNotFoundError";
    ErrorType["WORKSPACE_USER_NOT_FOUND_ERROR"] = "WorkspaceUserNotFoundError";
    ErrorType["INVALID_ROLE_ERROR"] = "InvalidRoleError";
    ErrorType["INVALID_NICKNAME_ERROR"] = "InvalidNicknameError";
    ErrorType["COMPANY_NOT_FOUND_ERROR"] = "CompanyNotFoundError";
    ErrorType["WORKSPACE_ALREADY_EXISTS_ERROR"] = "WorkspaceAlreadyExistsError";
    ErrorType["COMPANY_SERVICE_NOT_FOUND"] = "CompanyServiceNotFound";
    ErrorType["ACCOUNT_IS_NOT_ACTIVATED"] = "AccountIsNotActivated";
    ErrorType["KS365SERVICE_NOT_FOUND_ERROR"] = "Ks365ServiceNotFoundError";
    ErrorType["KS365DATA_CENTER_NOT_FOUND"] = "Ks365DataCenterNotFound";
    ErrorType["WRONG_ESTIMATED_ENDPOINTS_COUNT_ERROR"] = "WrongEstimatedEndpointsCountError";
    ErrorType["SECURITY_CENTER_NOT_FOUND"] = "SecurityCenterNotFound";
    ErrorType["USER_NOT_AUTHORIZED_FOR_SIGNING_CRS"] = "UserNotAuthorizedForSigningCrs";
    ErrorType["WORKSPACE_LICENSE_EXPIRED"] = "WorkspaceLicenseExpired";
    ErrorType["WORKSPACE_LICENSE_NOT_FOUND"] = "WorkspaceLicenseNotFound";
    ErrorType["LICENSE_INFORMATION_NOT_FOUND"] = "LicenseInformationNotFound";
    ErrorType["CAPTCHA_REQUIRED"] = "CaptchaRequired";
    ErrorType["INVALID_CAPTCHA_ANSWER"] = "InvalidCaptchaAnswer";
    ErrorType["COMPANY_SERVICE_NOT_MARKED_FOR_DELETION"] = "CompanyServiceNotMarkedForDeletion";
    ErrorType["COMPANY_SERVICE_ALREADY_MARKED_FOR_DELETION"] = "CompanyServiceAlreadyMarkedForDeletion";
})(ErrorType || (exports.ErrorType = ErrorType = {}));
